import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "../components/AuthLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiErrorDetail } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1669846125517-6ea5fd9dc9af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB3b3JraW5nJTIwbGFwdG9wJTIwd2FybSUyMHdpbmRvd3xlbnwwfHx8fDE3ODg0NzIwMjV8MA&ixlib=rb-4.1.0&q=85";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="Enter a new password for your account." image={IMG}>
      {!token ? (
        <div className="rounded-lg border border-[#E5E2DC] bg-white p-6">
          <p className="text-[#1F2924]">This reset link is invalid or missing a token.</p>
          <Link to="/forgot-password" className="mt-4 inline-block text-sm font-medium text-[#2C5545] hover:underline">Request a new link</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div className="space-y-2">
            <Label htmlFor="password">New Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
          </div>
          <Button type="submit" disabled={busy} data-testid="reset-submit"
            className="w-full bg-[#2C5545] hover:bg-[#224336] rounded-lg py-6 text-base font-semibold">
            {busy ? "Updating…" : "Update Password"}
          </Button>
          <Link to="/login" className="block text-center text-sm font-medium text-[#2C5545] hover:underline">Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}
